import { createAction } from 'redux-actions';

export const getFreeToSpend = createAction('GET_FREE_TO_SPEND');
export const getFreeToSpendSuccess = createAction('GET_FREE_TO_SPEND_SUCCESS');
export const getFreeToSpendFailure = createAction('GET_FREE_TO_SPEND_FAILURE');

export const createFreeToSpend = createAction('CREATE_FREE_TO_SPEND', (payload) => payload, (payload, meta) => meta);
export const createFreeToSpendSuccess = createAction('CREATE_FREE_TO_SPEND_SUCCESS');
export const createFreeToSpendFailure = createAction('CREATE_FREE_TO_SPEND_FAILURE');

export const updateFreeToSpend = createAction('UPDATE_FREE_TO_SPEND', (payload) => payload, (payload, meta) => meta);
export const updateFreeToSpendSuccess = createAction('UPDATE_FREE_TO_SPEND_SUCCESS');
export const updateFreeToSpendFailure = createAction('UPDATE_FREE_TO_SPEND_FAILURE');

export const deleteFreeToSpend = createAction('DELETE_FREE_TO_SPEND', (payload) => payload, (payload, meta) => meta);
export const deleteFreeToSpendSuccess = createAction('DELETE_FREE_TO_SPEND_SUCCESS');
export const deleteFreeToSpendFailure = createAction('DELETE_FREE_TO_SPEND_FAILURE');
